/* Wamory — Today's deals countdown (deals page and the home-page strip).
   Each [data-wd-timer] counts down to its data-wd-ends time, written by the store's daily deals automation.
   Without it, the shared 24-hour cycle (from 2026-10-14 14:46 UTC) is used. When a round ends, the page reloads
   once so the next ten products and their prices appear. */
(() => {
  const page = document.querySelector('[data-wd-page]');
  if (page) {
    const search = page.querySelector('[data-wd-search]'), header = page.querySelector('.header-main');
    if (header && search) header.append(search);
  }
  const timers = [...document.querySelectorAll('[data-wd-timer]')];
  if (!timers.length) return;
  const cycleStart = Date.parse('2026-10-14T14:46:00Z'), cycleLength = 864e5;
  const fallbackEnd = () => { const elapsed = Math.max(0, Date.now() - cycleStart); return Date.now() + (cycleLength - elapsed % cycleLength); };
  const pad = n => String(n).padStart(2, '0');
  let reloaded = false;
  const tick = () => {
    timers.forEach(timer => {
      let end = Number(timer.dataset.wdEndsTs) * 1000 || Date.parse(timer.dataset.wdEnds || '');
      if (!(end > 0) || end - Date.now() > cycleLength * 2 || Date.now() - end > 15 * 60e3) end = fallbackEnd();
      let seconds = Math.ceil((end - Date.now()) / 1e3);
      if (seconds <= 0) {
        seconds = 0;
        // The automation can take a few minutes to swap the products; reload once, shortly after the end.
        if (!reloaded && Date.now() - end > 90e3) { reloaded = true; setTimeout(() => location.reload(), 500); }
      }
      const h = timer.querySelector('[data-wd-hours]'), m = timer.querySelector('[data-wd-minutes]'), s = timer.querySelector('[data-wd-seconds]');
      if (h) h.textContent = pad(Math.floor(seconds / 3600));
      if (m) m.textContent = pad(Math.floor(seconds % 3600 / 60));
      if (s) s.textContent = pad(seconds % 60);
    });
  };
  tick();
  const interval = setInterval(tick, 1e3);
  window.addEventListener('pagehide', () => clearInterval(interval), { once: true });
  window.addEventListener('pageshow', e => { if (e.persisted) location.reload(); });
})();
